import { IconType } from "@src/appV2/redesign/components/Icon.types";
import { useWorkplaceMenuPriviligesProviderContext } from "../Navigation/priviligesProviders/WorkplaceMenuPriviligesProvider";
import { useHistory } from "react-router-dom";
import { getLocation } from "@src/appV2/redesign/utils/routes";

export function useNavHeader(): {
  displayHelpButton: boolean;
  iconTypeHelpButton: IconType;
  onClickHelpButton: () => void;

  displayNotificationsButton: boolean;
  iconTypeNotificationsButton: IconType;
  onClickNotificationsButton: () => void;

  displaySettingsButton: boolean;
  iconTypeSettingsButton: IconType;
  onClickSettingsButton: () => void;
} {
  const workplaceMenuPriviliges = useWorkplaceMenuPriviligesProviderContext();
  const history = useHistory();

  const displayHelpButton = workplaceMenuPriviliges.helpCenter ?? false;
  const iconTypeHelpButton = "question-circle";
  function onClickHelpButton() {
    history.push(getLocation("helpCenter"));
  }

  const displayNotificationsButton = true;
  const iconTypeNotificationsButton = "bell-solid";
  function onClickNotificationsButton() {
    // TODO
  }

  const displaySettingsButton = workplaceMenuPriviliges.managementSection?.settings ?? false;
  const iconTypeSettingsButton = "cogwheel";
  function onClickSettingsButton() {
    history.push(getLocation("facilitySettings"));
  }

  return {
    displayHelpButton,
    iconTypeHelpButton,
    onClickHelpButton,

    displayNotificationsButton,
    iconTypeNotificationsButton,
    onClickNotificationsButton,

    displaySettingsButton,
    iconTypeSettingsButton,
    onClickSettingsButton,
  };
}
